import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "BankOfJS",
  "use": "BankOfJS-usage",
  "viewBox": "0 0 68 67.969",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 68 67.969\" id=\"BankOfJS\">\r\n<defs>\r\n    <style>\r\n      #BankOfJS .cls-1 {\r\n        fill: #3951e6;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"BankOfJS_建设银行logo\" class=\"cls-1\" d=\"M3180.91,743.7c-4.79-5.525-9.28-5.559-9.28-5.559s10.76-4.717,20.46,5.1l10.27,10.412a1.689,1.689,0,0,1,.63.969,6.125,6.125,0,0,1-.55,1.436l-4.71,4.568L3180.91,743.7h0Zm20.21,29.406a2.022,2.022,0,0,1,1.3.106,0.606,0.606,0,0,1,.35.66C3201.97,791.2,3187.82,805,3170.88,805c-17.19,0-31.88-14.376-31.88-32.326a32,32,0,0,1,26.58-31.91,11.42,11.42,0,0,1,10.26,3.455l19.19,19.339-6.59,6.774a2.342,2.342,0,0,1-1.57.672,3.02,3.02,0,0,1-1.28-.876l-14.26-14.448a0.646,0.646,0,0,0-.91,0l-16.2,16.378a0.66,0.66,0,0,0,0,.922l16.18,16.348a0.637,0.637,0,0,0,.91,0l15.23-15.362a7.569,7.569,0,0,1,.95-0.706,4.078,4.078,0,0,1,1.27-.153h12.36Zm0,0\" transform=\"translate(-3137 -737.031)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/BankOfJS.svg
// module id = z1Kb
// module chunks = 37